export const GUIDE_ARTICLE_CARD_RADIUS =
  "rounded-[1.25rem] md:rounded-2xl";

export function guideArticleLayoutId(slug: string) {
  return `guide-article-${slug}`;
}

export const GUIDE_ARTICLE_LAYOUT_TRANSITION = {
  type: "spring" as const,
  damping: 30,
  stiffness: 240,
  mass: 0.85,
};

export const GUIDE_ARTICLE_PAGE_REVEAL = {
  delay: 0.12,
  duration: 0.45,
  ease: [0.16, 1, 0.3, 1] as const,
};
